import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

export const ProtectedRoute = ({ component: Component, ...rest }) => {
  const authIndicator = useSelector((state) => {
    if (state.loginSuccesReducer != null)
      return state.loginSuccesReducer.data.isLoggedIn;
    else return false;
  });
  console.log("authIndicator " + authIndicator);
  return (
    <Route
      {...rest}
      render={(props) => {
        if (authIndicator) {
          return <Component {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: "/",
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};
